export const CheckIcon = ({ width, height, viewBox, fill, styles }) => (
  <svg
    width={width || '40'}
    height={height || '40'}
    viewBox={viewBox || '0 0 40 40'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles}
  >
    <path
      d="M13.75 20.625L18.75 25.625L26.25 14.375"
      stroke="#4F64D7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
